import React, { useEffect, useMemo, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import CustomModal from '../../../components/CustomModal';
import ForecastApiService from '../../../services/api/ForecastApiService';
import { formatPeriodoLabel } from '../../../services/forecast/periodoUtils';

const RANK_TIPO_PERIODO = { ANO: 0, SEMESTRE: 1, TRIMESTRE: 2 };

function FiltroAcompanhamentoForecast({ onAplicar }) {
    const [importacoes, setImportacoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(false);
    const [importacaoId, setImportacaoId] = useState('');

    useEffect(() => {
        ForecastApiService.listImportacoes()
            .then(resp => setImportacoes(resp.data?.items || []))
            .catch(() => setErro(true))
            .finally(() => setLoading(false));
    }, []);

    const opcoesOrdenadas = useMemo(() => {
        return [...importacoes].sort((a, b) => {
            if (b.ano !== a.ano) return b.ano - a.ano;
            const rankA = RANK_TIPO_PERIODO[a.tipo_periodo] ?? 99;
            const rankB = RANK_TIPO_PERIODO[b.tipo_periodo] ?? 99;
            if (rankA !== rankB) return rankA - rankB;
            return (a.periodo_numero || 0) - (b.periodo_numero || 0);
        });
    }, [importacoes]);

    const handleAplicar = () => {
        onAplicar({ importacaoId });
        CustomModal.hide();
    };

    return (
        <Form>
            <Form.Group>
                <Form.Label>Forecast</Form.Label>
                {loading ? (
                    <p className="text-muted small mb-0">Carregando…</p>
                ) : erro ? (
                    <p className="text-danger small mb-0">Erro ao buscar os forecasts existentes.</p>
                ) : opcoesOrdenadas.length === 0 ? (
                    <p className="text-muted small mb-0">Nenhum forecast importado ainda.</p>
                ) : (
                    <Form.Control
                        as="select"
                        value={importacaoId}
                        onChange={e => setImportacaoId(e.target.value)}
                    >
                        <option value="">Selecione um forecast…</option>
                        {opcoesOrdenadas.map(item => (
                            <option key={item.id} value={item.id}>
                                {formatPeriodoLabel(item.tipo_periodo, item.periodo_numero)} de {item.ano}
                            </option>
                        ))}
                    </Form.Control>
                )}
            </Form.Group>

            <div className="d-flex justify-content-end mt-3">
                <Button variant="primary" onClick={handleAplicar} disabled={!importacaoId}>
                    Aplicar Filtro
                </Button>
            </div>
        </Form>
    );
}

export default FiltroAcompanhamentoForecast;
